import { SessionEvent } from '../../common/data.js';
import { maybe, queue } from '../../common/util.js';
import { reportEventReported } from './api.js';
import { OuterData } from '../../common/pagedata.js';

let reported: Record<string, boolean> = {};
const reportingNow: Record<string, boolean> = {};

export function setUpTrackers(data: OuterData) {

	const w = window as any;
	
	const ga = w.ga;
	const tracker = ga?.getAll?.()[0];
	const gtag = w.gtag;
	
	if (tracker) {
		if (data.shortlink) {
			tracker.set('campaignMedium', 'affiliate');
			tracker.set('campaignSource', 'shortlink');
			tracker.set('campaignContent', data.shortlink);
		}
	}
	else if (gtag) {
		gtag('set', {
			user_id: data.user?.id,
			session_id: data.session,
		});
		if (data.shortlink) gtag('set', {
			campaign_medium: 'affiliate',
			campaign_source: 'shortlink',
			campaign_content: data.shortlink,
		});
	}
	
}

export const reportEventsFromServer = queue(async (events: SessionEvent[]) => {
	
	const t = Date.now();
	
	if (localStorage.reportedEvents) try {
		reported = JSON.parse(localStorage.reportedEvents);
	}
	catch (e) {
		console.error(e);
	}
	await Promise.all(events.map(async event => {
		let success = false;
		if (!reported[event.id] && !reportingNow[event.id]) {
			success = await reportToEverywhere(event).catch(e => {
				console.error(e);
				return false;
			});
		}
		if (success || reported[event.id]) {
			await reportEventReported({ event: event.id });
		}
	}));
	
});

async function reportToEverywhere(event: SessionEvent, server = false) {
	
	reportingNow[event.id] = true;
	const { action } = event;
	const promises: (Promise<any> | undefined)[] = [];
	
	promises.push(reportToGoogle(event));
	reportToBing(event);
	
	await Promise.race(promises);
	reported[event.id] = true;
	localStorage.reportedEvents = JSON.stringify(reported);
	
	await Promise.all(promises);
	return true;
	
}

async function reportToGoogle(event: SessionEvent) {
	try {
		
		const w = window as any;
		
		const gtag = w.gtag;
		const ga4 = event.extras?.ga4;
		const ga = w.ga;
		const tracker = ga?.getAll?.()[0];
		
		if (gtag && ga4 && !tracker) {
			await new Promise<void>(resolve => gtag(
				'event',
				ga4.event,
				{
					...ga4.params,
					event_callback: resolve,
				},
			));
		}
		else if (tracker) {
			await new Promise(resolve => tracker.send({
				hitType: 'event',
				eventCategory: event.category,
				eventAction: event.action,
				eventLabel: event.extras?.eventLabel,
				eventValue: maybe(event.extras?.eventValue, val => Math.round(Number(val))),
				hitCallback: resolve,
			}));
		}
		
	}
	catch (e) {
		console.error(e);
	}
}

function reportToBing(event: SessionEvent) {
	try {
		const w = window as any;
		w.uetq = w.uetq || [];
		const r = w.uetq.push('event', event.action, {
			event_category: event.category,
			event_label: event.extras?.eventLabel,
			event_value: event.extras?.eventValue,
		});
	}
	catch (e) {
		console.error(e);
	}
}
